// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".outerBorder[data-v-a2d6c930] {\n  border: 2px solid #1A7BEE;\n}\n.innerBorder[data-v-a2d6c930] {\n  border: 2px solid #ffffff;\n}\n@media screen and (max-width: 640px) {\n.innerBorder[data-v-a2d6c930] {\n    width: 38px;\n    height: 38px;\n}\n}\n.user-profile-avatar[data-v-a2d6c930] {\n  width: 43px;\n}", ""]);
// Exports
module.exports = exports;
